import React from "react";
import { MapLegendControl } from "../../../common/MapControls/MapControls";

export const Legend = () => (
  <MapLegendControl width="220px">
    <div style={{ fontWeight: "700", fontSize: "11px", marginBottom: "8px" }}>Recent Earthquakes</div>
    <img id="map_legend" src="/Earthquake/legend.jpg" alt="RIMES Legend" style={{ width: "100%", marginBottom: "6px" }} />
    <img id="map_heatmap" src="/Earthquake/heatmap.jpg" alt="Heatmap Legend" style={{ width: "100%" }} />
  </MapLegendControl>
);

export const LegendUSGS = () => (
  <MapLegendControl width="220px">
    <div style={{ fontWeight: "700", fontSize: "11px", marginBottom: "8px" }}>Recent Earthquakes</div>
    <img id="map_legend" src="/Earthquake/legend_usgs.png" alt="USGS Legend" style={{ width: "100%", marginBottom: "6px" }} />
    <img id="map_heatmap" src="/Earthquake/heatmap.jpg" alt="Heatmap Legend" style={{ width: "100%" }} />
  </MapLegendControl>
);
